/* eslint-disable no-console */
import { register } from 'register-service-worker';

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log('App is being served from cache by a service worker.');
    },
    registered() {
      console.log('Service worker has been registered.');
    },
    cached() {
      console.log('Content has been cached for offline use.');
    },
    updatefound() {
      console.log('New content is downloading...');
    },
    updated(registration) {
      console.log('New content is available; activating new Service Worker...');

      if (registration && registration.waiting) {
        try {
          // ✅ Envía mensaje para activar inmediatamente
          registration.waiting.postMessage({ type: 'SKIP_WAITING' });

          // ✅ Recarga cuando el SW pase a 'activated'
          registration.waiting.addEventListener('statechange', (e) => {
            if (e.target.state === 'activated') {
              console.log('New Service Worker activated. Reloading page...');
              window.location.reload();
            }
          });
        } catch (err) {
          console.error('Error forcing new Service Worker:', err);
        }
      }
    },
    offline() {
      console.log('No internet connection found. App is running in offline mode.');
    },
    error(error) {
      console.error('Error during service worker registration:', error);
    }
  });

  // ✅ Permite limpieza manual si se envía CLEAR_CACHE
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data && event.data.type === 'CLEAR_CACHE') {
      caches.keys().then((cacheNames) => {
        cacheNames.forEach((cacheName) => caches.delete(cacheName));
      });
      console.log('All caches cleared on demand.');
    }
    
    // ✅ Escuchar mensaje para recargar página
    if (event.data && event.data.type === 'RELOAD_PAGE') {
      console.log('Recargando página por actualización del service worker...');
      window.location.reload(true);
    }
  });
}